import { useState } from 'react'
import { RelatorioListSearchComponent } from './RelatorioSearchComponent'
import { RelatorioListToolbar } from './RelatorioListToolbar'

export const RelatorioListHeader = () => {
  // Exportar sem período destaca os campos de período como obrigatórios.
  const [forceDateRangeError, setForceDateRangeError] = useState(false)

  return (
    <div className='card-header border-0 pt-6'>
      <RelatorioListSearchComponent
        forceDateRangeError={forceDateRangeError}
        actions={<RelatorioListToolbar onPeriodoIncompleto={() => setForceDateRangeError(true)} />}
      />
    </div>
  )
}
